import { LocaleContext } from '../../contexts/language';
import React from 'react';

export const useLanguageLink = () => {
  const localeConfig = React.useContext(LocaleContext);
  const locale = localeConfig?.lang || 'en';

  const f = ( dest )=>{

    if (locale === 'en'||!dest?.startsWith('/')) {
      return dest;
    }

    return `/${locale}${dest}`;
  };
  
  return f;
};